import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-043a5d54"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "/", -1))
const _hoisted_6 = { key: 2 }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_8 = { class: "overSP" }
const _hoisted_9 = ["onMouseenter"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_miezz_select = _resolveComponent("miezz-select")!
  const _component_miezz_button = _resolveComponent("miezz-button")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_miezz_page_list = _resolveComponent("miezz-page-list")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_miezz_input = _resolveComponent("miezz-input")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_miezz_modal = _resolveComponent("miezz-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_miezz_page_list, {
      modelValue: _ctx.list,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.list) = $event)),
      onHandleGet: _ctx.handleGet,
      onHandleTopButtonClick: _ctx.handleTopButtonClick,
      onHandleRowButtonClick: _ctx.handleRowButtonClick,
      onHandleBottomButtonClick: _ctx.handleBottomButtonClick,
      onHandleRowDbClick: _ctx.handleRowDbClick
    }, {
      "dynamic-search-customize": _withCtx(({ model }) => [
        (model.Where.Prop == 'DynamicSearch_JoinCompanyTypes')
          ? (_openBlock(), _createBlock(_component_miezz_select, {
              key: 0,
              modelValue: model.Where.Value,
              "onUpdate:modelValue": ($event: any) => ((model.Where.Value) = $event),
              options: _ctx.companyTypes
            }, null, 8, ["modelValue", "onUpdate:modelValue", "options"]))
          : (model.Where.Prop == 'DynamicSearch_Status')
            ? (_openBlock(), _createBlock(_component_miezz_select, {
                key: 1,
                modelValue: model.Where.Value,
                "onUpdate:modelValue": ($event: any) => ((model.Where.Value) = $event),
                options: _ctx.EnumCompanyStatusOption
              }, null, 8, ["modelValue", "onUpdate:modelValue", "options"]))
            : (model.Where.Prop == 'DynamicSearch_JoinCompanyUsers')
              ? (_openBlock(), _createBlock(_component_miezz_select, {
                  key: 2,
                  modelValue: model.Where.Value,
                  "onUpdate:modelValue": ($event: any) => ((model.Where.Value) = $event),
                  options: _ctx.users
                }, null, 8, ["modelValue", "onUpdate:modelValue", "options"]))
              : (model.Where.Prop == 'DynamicSearch_ServiceProviderCompanyId')
                ? (_openBlock(), _createBlock(_component_miezz_select, {
                    key: 3,
                    modelValue: model.Where.Value,
                    "onUpdate:modelValue": ($event: any) => ((model.Where.Value) = $event),
                    options: _ctx.serviceProviders,
                    labelKey: "NameZh",
                    valueKey: "Id"
                  }, null, 8, ["modelValue", "onUpdate:modelValue", "options"]))
                : (model.Where.Prop == 'DynamicSearch_Source')
                  ? (_openBlock(), _createBlock(_component_miezz_select, {
                      key: 4,
                      modelValue: model.Where.Value,
                      "onUpdate:modelValue": ($event: any) => ((model.Where.Value) = $event),
                      options: _ctx.sources
                    }, null, 8, ["modelValue", "onUpdate:modelValue", "options"]))
                  : (model.Where.Prop == 'DynamicSearch_SalesmanId')
                    ? (_openBlock(), _createBlock(_component_miezz_select, {
                        key: 5,
                        modelValue: model.Where.Value,
                        "onUpdate:modelValue": ($event: any) => ((model.Where.Value) = $event),
                        options: _ctx.salesmans
                      }, null, 8, ["modelValue", "onUpdate:modelValue", "options"]))
                    : _createCommentVNode("", true)
      ]),
      column: _withCtx(({ model, row }) => [
        (model.Prop == 'InquiryHistory')
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              (row.InquiryHistory)
                ? (_openBlock(), _createElementBlock("a", {
                    key: 0,
                    href: "javascript:void",
                    style: {"text-decoration":"unset"},
                    onClick: ($event: any) => (_ctx.handleClickInquiryHistory(row))
                  }, "查看详情", 8, _hoisted_2))
                : (_openBlock(), _createElementBlock("span", _hoisted_3, "暂无数据"))
            ]))
          : _createCommentVNode("", true),
        (model.Prop == 'UserCount')
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createElementVNode("span", null, _toDisplayString(row.UserCount), 1),
              _hoisted_5,
              _createElementVNode("span", null, _toDisplayString(row.MaxUserCount ?? "-"), 1),
              _createVNode(_component_miezz_button, {
                model: _ctx.btnUpdateMaxUserCount,
                onHandleClick: (arg1, arg2) => _ctx.handleRowButtonClick(arg1, row, arg2)
              }, null, 8, ["model", "onHandleClick"])
            ]))
          : _createCommentVNode("", true),
        (model.Prop == 'JoinCompanyTypes')
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createVNode(_component_el_tooltip, {
                placement: "top",
                disabled: row.tooltipFlag,
                ref: 'tooltip' + row.Id,
                "show-after": 500
              }, {
                content: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row.JoinCompanyTypes, (p, index) => {
                    return (_openBlock(), _createElementBlock("span", { key: index }, [
                      _createElementVNode("span", null, [
                        _createTextVNode("【" + _toDisplayString(p.CompanyType?.Name) + "】", 1),
                        _hoisted_7
                      ])
                    ]))
                  }), 128))
                ]),
                default: _withCtx(() => [
                  _createElementVNode("span", _hoisted_8, [
                    _createElementVNode("span", {
                      onMouseenter: ($event: any) => (_ctx.visibilityChange($event, row))
                    }, _toDisplayString(row.JoinCompanyTypesLabel), 41, _hoisted_9)
                  ])
                ]),
                _: 2
              }, 1032, ["disabled"])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue", "onHandleGet", "onHandleTopButtonClick", "onHandleRowButtonClick", "onHandleBottomButtonClick", "onHandleRowDbClick"]),
    _createVNode(_component_miezz_modal, {
      modelValue: _ctx.modalUpdateMaxUserCount,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.modalUpdateMaxUserCount) = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          ref: "ref-form-max-user-count",
          model: _ctx.modalUpdateMaxUserCountData,
          rules: _ctx.modalUpdateMaxUserCountRules,
          "label-width": "150px"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              label: "状态",
              prop: "Status"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_switch, {
                  modelValue: _ctx.modalUpdateMaxUserCountData.Status,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.modalUpdateMaxUserCountData.Status) = $event)),
                  "active-value": true,
                  "inactive-value": false,
                  onChange: _ctx.handleMaxUserCountStatusChange
                }, null, 8, ["modelValue", "onChange"])
              ]),
              _: 1
            }),
            (_ctx.modalUpdateMaxUserCountData.Status)
              ? (_openBlock(), _createBlock(_component_el_form_item, {
                  key: 0,
                  label: "人数",
                  prop: "MaxUserCount"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_miezz_input, {
                      modelValue: _ctx.modalUpdateMaxUserCountData.MaxUserCount,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.modalUpdateMaxUserCountData.MaxUserCount) = $event))
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["model", "rules"])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}